import { createSlice } from "@reduxjs/toolkit";

export const ReportSlice = createSlice({
  name: "Report",
  initialState: {
    disable: "",
    Loading: true,
    Refresh: "",
    ClinicalReportDetails: [],
    ClinicalReportCount: [],
    ClinicalReportLoad: [],
    Currency: localStorage.getItem("currency_symbol")
      ? localStorage.getItem("currency_symbol")
      : "$",
  },
  reducers: {
    GetClinicalReportDetails: (state) => {
      state.Refresh = "";
      state.disable = true;
    },

    SetClinicalReportDetails: (state, action) => {
      state.Loading = false;
      state.ClinicalReportDetails = action.payload;
      state.disable = false;
    },

    setLoadingFalse: (state) => {
      state.Loading = false;
      state.disable = false;
    },

    SetClinicalReportLoad: (state, action) => {
      state.Loading = false;
      state.disable = false;
      state.ClinicalReportDetails = [
        ...state.ClinicalReportDetails,
        ...action.payload,
      ];
    },

    GetClinicalReportCount: (state) => {
      state.Refresh = "";
    },

    SetClinicalReportCount: (state, action) => {
      state.ClinicalReportCount = action.payload;
    },

    GetCurrency: (state) => {
      state.Refresh = "";
    },

    SetCurrency: (state, action) => {
      state.Currency = action.payload;
      state.Loading = false;
    },

    // Refresh: (state, action) => {
    //   if (isNaN(action.payload)) {
    //     alert("Its Not a number");
    //   } else {
    //     let message = "";
    //     if (action.payload === 1)
    //       message = "Profile Picture Updated Successfully";
    //     if (action.payload === 2)
    //       message = "Profile Picture Deleted Successfully";

    //     if (action.payload === 3)
    //       message = "Details Sent to Review Successfully";
    //   }

    //   state.Refresh = action.payload;
    // },
  },
});

export const {
  GetClinicalReportDetails,
  SetClinicalReportDetails,
  Refresh,
  GetClinicalReportCount,
  SetClinicalReportCount,
  SetClinicalReportLoad,
  GetCurrency,
  SetCurrency,
  setLoadingFalse
} = ReportSlice.actions;

export default ReportSlice.reducer;
